module.exports = __webpack_public_path__ + "static/media/abbiamo8.d79c2012.png";